<template>
    <div class="app-wrapper" :class="locale">
        <div class="main-container">
            <Navbar />
            <div class="main">
                <router-view/>
            </div>
        </div>
    </div>
    
</template>

<script>
import Navbar from './components/Navbar';
import {getDictionaries, getUserInstructions} from '@/api/app';

export default {
    name: 'Layout',
    components: {Navbar},
    data () {
        return {
            locale: 'zh'
        }
    },
    async created () {
        await this.getDictionaries();
    },
    mounted () {
        // this.getUserInfo();
        this.getUserInstructions();
        this.locale = localStorage.getItem('locale') || 'zh';

    },
    methods: {
        // 获取字典
        async getDictionaries () {
            let res = await getDictionaries();
            if (res.errcode == 0) {
                this.$store.commit('app/SET_DICTIONARIES', res.data)
            }
        },
        getUserInfo () {
            getUserInfo({}).then(res => {
                if (res.errcode == 0) {
                    this.$store.dispatch('app/setUserInfo', res.data);
                }
            })
        },
        // 获取用户须知
        getUserInstructions () {
            getUserInstructions({}).then(res => {
                if (res.errcode == 0) {
                    let data = res.data.orderInformation;

                    let expressArr = (data.express || '').split(/\n/);
                    let landExportsFullArr = (data.landExportsFull || '').split(/\n/);
                    let seaExportsFullArr = (data.seaExportsFull || '').split(/\n/);
                    let seaExportsPieceArr = (data.seaExportsPiece || '').split(/\n/);

                    this.$store.commit('app/SET_USER_INSTRUCTIONS', {data: expressArr, type: 'expressArr'});
                    this.$store.commit('app/SET_USER_INSTRUCTIONS', {data: landExportsFullArr, type: 'landExportsFullArr'});
                    this.$store.commit('app/SET_USER_INSTRUCTIONS', {data: seaExportsFullArr, type: 'seaExportsFullArr'});
                    this.$store.commit('app/SET_USER_INSTRUCTIONS', {data: seaExportsPieceArr, type: 'seaExportsPieceArr'});
                }1
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
    .main-container {
        min-height: 100vh;
        transition: all .3s;
        .main {
            height: calc(100vh - 50px);
            min-width: 1200px;
            margin: 0 auto;
            overflow-y: auto;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/index.vue